import { defineStore } from "pinia";
import { computed } from "vue";
import { pickBy } from "lodash-es";
import { useSceneNodesStore } from "../scene/sceneNodes.store";
import type { SceneNodeItem } from "../scene/SceneNodeItem";
import type { Subset } from "@/helpers/utility/Type";
import type { SceneTextData } from "./sceneTextData";
import { isSceneTextNode } from "./sceneTextFunctions";

export const useSceneTextStore = defineStore("model/sceneTexts", () => {
  const sceneNodeStore = useSceneNodesStore();

  async function create(options: Subset<SceneNodeItem<"text">>, data: Partial<SceneTextData> = {}) {
    const filledData: SceneTextData = {
      text: options.data?.text ?? data.text ?? "",
      connected: options.data?.connected ?? data.connected ?? false,
      connectedUid: options.data?.connectedUid ?? data.connectedUid ?? null,
      connectedProperty: options.data?.connectedProperty ?? data.connectedProperty ?? null,
      stylable: options.data?.stylable ?? data.stylable ?? true,
    };

    return await sceneNodeStore.create({
      ...options,
      dataType: "text",
      data: filledData
    });
  }

  const items = computed(() => {
    return pickBy(sceneNodeStore.items, isSceneTextNode);
  });

  const byUid = computed(() => {
    return pickBy(sceneNodeStore.byUid, isSceneTextNode);
  });

  function $reset() {
    // handled by sceneNodeStore.
    return;
  }

  return {
    create,
    items,
    byUid,
    $reset
  }
});
